export const CLS_SHELL_ORIGIN = import.meta.env.VITE_CLS_SHELL_ORIGIN || "https://completelawsupport.com";

export function postToClsShell(message) {
  if (window.parent === window) return;
  window.parent.postMessage(message, CLS_SHELL_ORIGIN);
}

export function isClsShellMessage(event) {
  return event.source === window.parent && event.origin === CLS_SHELL_ORIGIN;
}
